import { render, staticRenderFns } from "./ReinviteDialog.vue?vue&type=template&id=afaf1dea&"
import script from "./ReinviteDialog.vue?vue&type=script&lang=js&"
export * from "./ReinviteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports